import { dto_Customer, dto_CustomerAddress } from "../classes/dto-customer";

export const resolveAddressPhoneNo = (address, fallbackPhoneNo = "") =>
  String(
    address?.PhoneNo ??
      address?.PHONENUMBER ??
      address?.PhoneNumber ??
      address?.MobileNo ??
      address?.MobileNumber ??
      fallbackPhoneNo ??
      "",
  ).trim();

export const resolveOrderDeliveryPhoneNo = () => {
  const deliveryPhoneNo = resolveAddressPhoneNo(dto_CustomerAddress);
  if (deliveryPhoneNo !== "") {
    return deliveryPhoneNo;
  }

  return String(dto_Customer.PhoneNo || "").trim();
};
